import Footer from './Footer'
import Navbar from './Navbar'

interface Props {
  children: React.ReactNode
  className?: string
}

export default function Page({ children, className }: Props) {
  return (
    <div
      className={`flex flex-row flex-1 max-w-screen min-h-screen overflow-x-hidden justify-center bg-white/10 over ${className}`}
    >
      <div className='flex flex-col flex-1 max-w-[1920px] min-h-screen bg-white'>
        <Navbar />
        {children}
        <Footer />
      </div>
    </div>
  )
}
